<template>
  <div class="mainContainer">
    <div class="videoCollectionContainer" v-show="collectionRight">
      <div class="collectionInputContainer">
        <p class="label"><span class="requireIcon">*</span>合集标题</p>
        <el-input v-model="collectionTitle" placeholder="请输入标题" clearable maxlength="70" show-word-limit></el-input>
      </div>
      <div class="collectionInputContainer" style="align-items: start; margin-top: 32px">
        <p class="label"><span class="requireIcon">*</span>合集封面</p>
        <el-upload action="no" accept="image/*" :before-upload="onBeforeUploadThumb" :http-request="uploadThumbFn"
          :show-file-list="false" class="thumbImgUploader">
          <img :src="collectionThumb" class="thumbImg" />
        </el-upload>
      </div>
      <p class="thumbAlert">
        支持jpg、jpeg、png、GIF格式，大小2MB以内，建议比例4：3
      </p>
      <div class="collectionInputContainer" style="justify-content: space-between;">
        <div class="collectionInputInner">
          <p class="label"><span class="requireIcon">*</span>合集{{ isScript == 1 ? '文章' : '视频' }}</p>
          <div class="submitBtn" @click="openVideos">添加{{ isScript == 1 ? '文章' : '视频' }}</div>
        </div>
        <div class="footerBtns">
          <div class="cancelBtn" @click="$router.go(-1)" v-if="!$route.query.nvpl_series_id">取 消</div>
          <el-button type="primary" class="submitBtnP" @click="submitCollection()">{{
            $route.query.nvpl_series_id ? "保存" : "创建"
          }}合集</el-button>
        </div>
      </div>
      <draggable class="scriptList" v-model="collectionList" @end="onDragEnd">
        <div v-for="(item, index) in collectionList" :key="index" class="scriptListItem">
          <div class="cover-container" v-if="item.n_cover_url.length > 0">
            <el-image class="cover" fit="cover" :src="item.n_cover_url[0]" :preview-src-list="item.n_cover_url" />
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <p class="title" @click="toDetail(item)">
                {{ item.n_title }}
              </p>
              <p class="create-time">{{ item.n_publish_time }}</p>
            </div>
            <div class="infoContainer action-bar">
              <div class="ext-info">
                <span>展现 {{ item.sum_watch_num }}</span>
                <span>评论 {{ item.ndr_comment_num }}</span>
                <span>点赞 {{ item.sum_like_num }}</span>
              </div>
              <div class="actionContainer">
                <p class="btns" @click="deleteCollect(index)">
                  <span>移除合集</span>
                </p>
                <p class="btns">
                  <el-popover placement="top" width="260" v-model="item.visible" @show="sortShow(index)">
                    <p>当前顺序第{{ index + 1 }}位</p>
                    <p>
                      更改为第<el-input v-model="item.indexChange" placeholder="" type="number"
                        style="width: 80px; height: 25px; margin: 10px 10px"></el-input>位
                    </p>
                    <div style="text-align: right; margin: 20px 0 0 0">
                      <el-button size="mini" type="text" @click="item.visible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="sortSubmit(item, index)">确定</el-button>
                    </div>
                    <span slot="reference">更改顺序</span>
                  </el-popover>
                </p>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <div class="noCollectionRight" v-show="!collectionRight">
      <img src="../../assets/level/noRight.png" class="noRightIcon" />
      <p class="rightWarning">您当前还未到达Lv2，暂时无法使用哦～</p>
      <p class="toRights" @click="toRights()">立即提升等级></p>
    </div>

    <el-dialog title="添加到合集中" :visible.sync="collectionAddVisible" width="1000px" top="5vh"
      class="collectionAddContainer" :close-on-click-modal="false">
      <el-input v-model="collectionAddKeyword" placeholder="请输入关键词" clearable class="collectionAddKeyword"
        @keyup.enter.native="getVideoList(1)" @clear="openVideos"></el-input>
      <el-button type="primary" @click="getVideoList(1)">查 询</el-button>
      <div class="videoCollectContainer publicScroll">
        <div v-for="(item, index) in collectionAddList" :key="index" class="scriptListItem">
          <el-checkbox v-model="item.checked" @change="(checked) => handleCheckVideo(checked, item)"></el-checkbox>
          <div class="bgContainer">
            <div class="cover-container" v-if="item.n_cover_url.length > 0">
              <el-image class="cover" fit="cover" :src="item.n_cover_url[0]" :preview-src-list="item.n_cover_url" />
            </div>
            <div class="info-box">
              <div class="infoContainer">
                <p class="title" @click="toDetail(item)">
                  {{ item.n_title }}
                </p>
              </div>
              <p class="create-time">发布于{{ item.n_create_time }}</p>
              <div class="infoContainer action-bar">
                <div class="ext-info">
                  <span>展现 {{ item.sum_watch_num }}</span>
                  <span>评论 {{ item.ndr_comment_num }}</span>
                  <span>点赞 {{ item.sum_like_num }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
        <img src="../../assets/script/no.png" class="noDataImg" />
        <p class="noDataText">暂无数据</p>
      </div>
      <el-pagination background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" />
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="collectionAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideosFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  RESOURCE_HOST,
  SWNEWS_HOST,
} from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      isScript: true,
      collectionTitle: "",
      collectionThumb: require("../../assets/script/uploadF.png"),
      collectionList: [],
      collectionAddVisible: false,
      collectionAddList: [],
      pageSize: 20,
      currentPage: 1,
      total: 1,
      collectionAddKeyword: "",
      currentAddKeyword: "",
      collectionAddChecks: [],
      collectionRight: false,
      belong_id_Pack: "",
    };
  },
  created() {
    if (this.$route.query.packType == 2) {
      this.isScript = false;
    }
    if (this.$route.query.nvpl_series_id) {
      this.belong_id_Pack = this.$route.query.nvpl_series_id;
      this.getCollectionDetail();
    }
    this.getRight();
  },
  methods: {
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          scriptId: item.nm_id,
          nid: item.n_id,
          isMine: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    onBeforeUploadThumb(file) {
      const isImage = file.type.indexOf("image/") >= 0;
      if (!isImage) {
        this.$message.error("请上传图片！");
        return false;
      } else {
        return true;
      }
    },
    uploadThumbFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.collectionThumb = data.url;
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    onDragEnd() {
      //console.log(this.collectionList);
    },
    deleteCollect(index) {
      this.$confirm("确认移除合集吗？", "移除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.collectionList.splice(index, 1);
        })
        .catch(() => { });
    },
    sortShow(index) {
      this.collectionList[index].indexChange = index + 1;
    },
    sortSubmit(item, index) {
      item.indexChange = parseInt(item.indexChange);
      if (item.indexChange < 1) {
        this.$message({
          message: "请输入正确的位数数字",
          type: "warning",
        });
      } else if (index + 1 > item.indexChange) {
        this.collectionList.splice(
          item.indexChange - 1,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index + 1, 1);
        item.visible = false;
      } else {
        this.collectionList.splice(
          item.indexChange,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index, 1);
        item.visible = false;
      }
    },
    openVideos() {
      this.currentAddKeyword = "";
      this.collectionAddKeyword = "";
      this.currentPage = 1;
      this.collectionAddChecks = JSON.parse(
        JSON.stringify(this.collectionList)
      );
      this.getVideoList();
      this.collectionAddVisible = true;

      this.$nextTick(() => {
        document.getElementsByClassName(
          "videoCollectContainer"
        )[0].scrollTop = 0;
      });
    },
    getVideoList(isSearch) {
      if (isSearch) {
        this.currentAddKeyword = this.collectionAddKeyword;
        this.currentPage = 1;
      }
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/newsPack/getUserWaitVideoList?page=${this.currentPage}&size=${this.pageSize}&n_title=${this.currentAddKeyword}&pack_type=${this.$route.query.packType}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.data.forEach((item) => {
              if (this.checkCollection(item.n_id) > -1) {
                item.checked = true;
              } else {
                item.checked = false;
              }
              item.indexChange = "";
              item.visible = false;
              item.n_cover_url = JSON.parse(item.n_cover_url);
            });
            this.collectionAddList = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getVideoList();

      document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
    },
    handleCheckVideo(val, item) {
      if (val) {
        if (this.checkCollection(item.n_id) < 0) {
          this.collectionAddChecks.unshift(item);
        }
      } else {
        if (this.checkCollection(item.n_id) > -1) {
          this.collectionAddChecks.splice(this.checkCollection(item.n_id), 1);
        }
      }
    },
    checkCollection(itemId) {
      let itemIndex = -1;
      this.collectionAddChecks.forEach((item, index) => {
        if (item.n_id == itemId) {
          itemIndex = index;
        }
      });
      return itemIndex;
    },
    addVideosFn() {
      this.collectionList = JSON.parse(
        JSON.stringify(this.collectionAddChecks)
      );
      this.collectionAddVisible = false;
    },
    submitCollection() {
      if (/^\s*$/.test(this.collectionTitle)) {
        this.$message({
          message: "请输入合集标题",
          type: "warning",
        });
      } else if (
        this.collectionThumb.indexOf("dingnews.net") < 0 &&
        this.collectionThumb.indexOf("topnews.cn") < 0 &&
        this.collectionThumb.indexOf("dingxinwen.cn") < 0
      ) {
        this.$message({
          message: "请上传合集封面",
          type: "warning",
        });
      } else if (this.collectionList.length == 0) {
        this.$message({
          message: "请选择至少一条内容",
          type: "warning",
        });
      } else {
        let n_ids = [];
        this.collectionList.forEach((item) => {
          n_ids.push(item.n_id);
        });
        let request = {
          title: this.collectionTitle,
          cover_url: this.collectionThumb,
          n_ids: n_ids.join(","),
          pack_type: this.$route.query.packType,
        };
        let url = `${RESOURCE_HOST}/api/newsPack/add`;
        if (this.belong_id_Pack) {
          request.nvpl_series_id = this.belong_id_Pack;
          url = `${RESOURCE_HOST}/api/newsPack/edit`;
        }
        this.$axios.post(url, request).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `${this.belong_id_Pack ? "保存" : "创建"}成功`,
              type: "warning",
            });

            this.$router.push({
              path: "/personalScript",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    getCollectionDetail() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/newsPack/getDetail?nvpl_series_id=${this.belong_id_Pack}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.detail.forEach((item) => {
              item.indexChange = "";
              item.visible = false;
              if (typeof item.n_cover_url == "string") {
                item.n_cover_url = JSON.parse(item.n_cover_url);
              }
            });
            this.collectionTitle = res.data.data.title;
            this.collectionThumb = res.data.data.cover_url;
            this.collectionList = res.data.data.detail;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toRights() {
      this.$router.push({
        path: "/rights",
      });
    },
    getRight() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserLevelList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.user_privilege_list.forEach((item) => {
              if (
                item.privilege_name == "创建合集" &&
                item.is_open == 1
              ) {
                this.collectionRight = true;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer {
  border-radius: 8px;
  background-color: #fff;
  height: calc(100vh - 100px);

  .videoCollectionContainer {
    padding: 30px 40px;
    position: relative;
    background-color: #fff;

    .collectionInputContainer {
      display: flex;
      align-items: center;

      .label {
        color: rgb(51, 51, 51);
        font-size: 14px;
        width: 100px;
        flex-shrink: 0;
        font-weight: bold;

        span {
          color: red;
          font-weight: bold;
        }
      }

      .el-input {
        margin-bottom: 0;
        margin-right: 0;
      }

      .thumbImgUploader {
        width: 165px;
        height: 124px;
      }

      .el-upload {
        width: 165px;
        height: 124px;
      }

      .thumbImg {
        width: 165px;
        height: 124px;
        cursor: pointer;
        object-fit: cover;
      }

      .submitBtn {
        width: 122px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
      }

      .collectionInputInner {
        display: flex;
        align-items: center;
      }

      .footerBtns {
        display: flex;
        align-items: center;

        .cancelBtn {
          width: 122px;
          border: 1px solid #dcdfe6;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          border-radius: 4px;
          color: #333;
          line-height: 36px;
          display: inline-block;
          margin-right: 12px;
        }

        .submitBtnP {
          width: 122px;
          height: 36px;
          display: block;
          padding: 8px 20px;
        }
      }
    }

    .thumbAlert {
      font-size: 12px;
      color: #999999;
      line-height: 20px;
      margin: 8px 0 32px 100px;
    }

    .scriptList {
      border-top: 1px solid #edf1f8;
      padding: 16px 0 32px 0;
      margin-top: 32px;

      .scriptListItem {
        border-bottom: 1px solid #edf1f8;
        padding: 16px 0;
        display: flex;
        min-height: 90px;
        box-sizing: content-box;

        .cover-container {
          width: 160px;
          height: 90px;
          border-radius: 6px;
          overflow: hidden;
          background: #ccc;
          margin-right: 20px;

          .cover {
            height: 100%;
            width: 100%;
          }
        }

        .info-box {
          flex: 1;
          position: relative;

          .infoContainer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
              width: calc(100% - 180px);
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              color: #333333;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              line-height: 20px;
            }

            .create-time {
              color: #999999;
              font-size: 14px;
            }

            .actionContainer {
              display: flex;
              line-height: 30px;

              .btns {
                margin-left: 20px;
                color: #5574e7;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }

          .infoContainer.action-bar {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;

            .ext-info {
              color: #999999;

              span {
                margin-right: 20px;
              }
            }

            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }
        }
      }

      .scriptListItem:last-child {
        border-bottom: 0;
      }
    }
  }

  .noCollectionRight {
    padding: 40px 60px 240px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .noRightIcon {
      width: 182px;
      margin-top: 177px;
    }

    .rightWarning {
      color: #333333;
      font-family: "PingFang SC";
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 39px;
    }

    .toRights {
      color: #ea0e0e;
      font-family: "PingFang SC";
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 7px;
      cursor: pointer;
    }
  }

  /deep/.collectionAddContainer {
    .el-dialog {
      height: 86vh;

      .el-dialog__body {
        padding-top: 10px;
      }

      .collectionAddKeyword {
        width: 350px;
        margin-bottom: 15px;
      }

      .searchNoDataContainer {
        width: 100%;
        height: calc(86vh - 245px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .noDataText {
          margin-top: 21px;
          font-size: 20px;
          color: rgb(204, 204, 204);
        }
      }

      .videoCollectContainer {
        width: 100%;
        max-height: calc(86vh - 245px);
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;

        .scriptListItem {
          width: calc(50% - 15px);
          padding: 8px 0;
          display: flex;
          height: 110px;
          box-sizing: content-box;
          margin-right: 15px;

          .el-checkbox {
            margin: 0 10px 0 0;
            display: flex;
            align-items: center;
          }

          .bgContainer {
            width: calc(100% - 29px);
            background-color: #f6f7f9;
            display: flex;
            padding: 10px;
            border-radius: 5px;
          }

          .cover-container {
            width: 160px;
            height: 90px;
            border-radius: 6px;
            overflow: hidden;
            background: #ccc;
            margin-right: 10px;
            flex-shrink: 0;

            .cover {
              height: 100%;
              width: 100%;
            }
          }

          .info-box {
            flex: 1;
            position: relative;
            width: calc(100% - 210px);

            .title {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              color: #333333;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              line-height: 20px;
              height: 40px;
              margin-bottom: 13px;
            }
          }

          .create-time {
            color: #999999;
            font-size: 14px;
          }

          .infoContainer.action-bar {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;

            .ext-info {
              color: #999999;

              span {
                margin-right: 10px;
              }
            }

            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }
        }
      }

      .el-dialog__footer {
        margin-top: 10px;
      }
    }
  }
}
</style>
